import { FadeUp } from './Reveal';

export default function SectionHeading({ eyebrow, title, description, align = 'left', light = false }) {
  const alignCls = align === 'center' ? 'text-center items-center' : 'text-left items-start';
  return (
    <FadeUp className={`flex flex-col gap-4 ${alignCls}`}>
      <span className="eyebrow">{eyebrow}</span>
      <h2
        className={`max-w-3xl font-display text-3xl font-bold tracking-tight md:text-4xl lg:text-[2.75rem] lg:leading-[1.15] ${
          light ? 'text-white' : 'text-navy dark:text-white'
        }`}
      >
        {title}
      </h2>
      {description && (
        <p className={`max-w-2xl text-base leading-relaxed md:text-lg ${light ? 'text-white/70' : 'text-muted-c'}`}>
          {description}
        </p>
      )}
    </FadeUp>
  );
}
